// @flow
import * as actionTypes from '../actionTypes/parametersTypes'

const { CHANGE_ACTIVE_SORT, TOGGLE_INITIAL_MOUNT } = actionTypes

export function toggleInitialMount(): Object {
  return {
    type: TOGGLE_INITIAL_MOUNT
  }
}

export function changeActiveSort(activeSort: ?Object): Object {
  return (dispatch, getState) => {
    if (!activeSort) {
      return {
        type: CHANGE_ACTIVE_SORT,
        activeSort: getState().parameters.initialSort
      }
    }
    return {
      type: CHANGE_ACTIVE_SORT,
      activeSort
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/actions/parameters.js